package pl.zar.tikthrow.shared.domain

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
enum class Platform {
    YOUTUBE, TIKTOK, FACEBOOK, INSTAGRAM, TWITTER, DISCORD;

    /** Human-readable label for UI display (not serialized — enum entries serialize by name). */
    val displayName: String
        get() = when (this) {
            YOUTUBE -> "YouTube"
            TIKTOK -> "TikTok"
            FACEBOOK -> "Facebook"
            INSTAGRAM -> "Instagram"
            TWITTER -> "X (Twitter)"
            DISCORD -> "Discord"
        }

    companion object {
        /** Case-insensitive parse; null when no entry matches or value is blank. */
        fun fromString(value: String): Platform? =
            entries.firstOrNull { it.name.equals(value.trim(), ignoreCase = true) }
    }
}

@Serializable
data class User(val id: String, val email: String, val displayName: String)

@Serializable
enum class ContentType {
    TEXT, IMAGE, VIDEO;

    companion object {
        /** Case-insensitive parse; null when no entry matches or value is blank. */
        fun fromString(value: String): ContentType? =
            entries.firstOrNull { it.name.equals(value.trim(), ignoreCase = true) }
    }
}

data class Post(
    val id: String,
    val accountId: String,
    val externalPostId: String,
    val contentType: ContentType,
    val textContent: String?,
    val mediaUrl: String?,
    val thumbnailUrl: String?,
    val authorName: String,
    val authorAvatarUrl: String?,
    val postUrl: String,
    val publishedAt: Instant,
    val likeCount: Int,
    val createdAt: Instant,
    val updatedAt: Instant,
)

data class SocialMediaAccount(
    val id: String,
    val platform: Platform,
    val accountHandle: String,
    val displayName: String?,
    val avatarUrl: String?,
    val isActive: Boolean,
    val createdAt: Instant,
    val updatedAt: Instant,
)

/** UI label for an account: the display name when set, otherwise the handle. */
fun SocialMediaAccount.getDisplayNameOrHandle(): String =
    displayName?.trim()?.takeIf { it.isNotEmpty() } ?: accountHandle
